/**
 * 
 * key
 * 
 */


const key = 'TWFwcGluZ19FcXVpcG1lbnQ='

export default key 